import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { DataGrid, SearchPanel, Selection, Column, Pager, Paging, Scrolling } from 'devextreme-react/data-grid';
import { getEmpleados } from '../utils/api';
import { notificacionError } from '../utils/alerts';
import { Hypnosis } from "react-cssfx-loading";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Empleados(props) {
    const [show, setShow] = useState(false);
    const [infoEmpleado, setInfoEmpleado] = useState({ id: 0, noEmpleado: 0, nombre: "" });
    const [empleados, setEmpleados] = useState(null);
    const [loadingE, setLoadingE] = useState(false);

    const allowedPageSizes = [5, 10, 50, 100, 'Todos'];

    useEffect(() => {
        setShow(props.abrirModal);
    })

    useEffect(() => {
        setLoadingE(true);
        getEmpleados()
            .then(resp => {
                if (resp.status === 200) {
                    setEmpleados(resp.data);
                }
                setLoadingE(false);
            })
            .catch(err => {
                setLoadingE(false);
                console.log(err);
                notificacionError("Intente nuevamente o comuniquese con el administrador del sistema");
            });
    }, [])

    const cerrarModal = () => {
        setInfoEmpleado({ id: 0, noEmpleado: 0, nombre: "" });
        props.cerrarModal(false)
        setShow(false);
    }

    const cerrarModalInfo = (data) => {
        props.infoEmpleado({ id: data.id, noEmpleado: data.noEmpleado, nombre: data.nombre });
        cerrarModal();
    }

    const onSelectionChanged = ({ selectedRowsData }) => {
        const data = selectedRowsData[0];
        let nombre = `${data.CNCDIRID} - ${data.CNCDIRNOM}`;
        setInfoEmpleado({ id: data.CNCDIRID, noEmpleado: data.CNCDIRID, nombre: nombre });
    }

    return (
        <div>
            <Modal isOpen={show} toggle={cerrarModal} backdrop="static" size="lg">
                <ModalHeader>Empleados</ModalHeader>
                <ModalBody>
                    {loadingE
                        ?
                        <Hypnosis width="100px" height="100px" style={{ margin: "0 auto" }} />
                        :
                        <DataGrid
                            dataSource={empleados}
                            showBorders={true}
                            hoverStateEnabled={true}
                            onSelectionChanged={onSelectionChanged}
                        >

                            <Selection mode="single" />
                            <SearchPanel
                                visible={true}
                                width={240}
                                placeholder="Buscar..." />
                            <Scrolling rowRenderingMode='virtual'></Scrolling>
                            <Paging defaultPageSize={5} />
                            <Pager
                                visible={true}
                                allowedPageSizes={allowedPageSizes}
                                displayMode="compact"
                                showPageSizeSelector={true}
                                showInfo={true}
                                showNavigationButtons={true}
                            />
                            <Column dataField="CNCDIRID" caption="Numero Empleado" />
                            <Column dataField="CNCDIRNOM" caption="Empleado" />
                        </DataGrid>
                    }
                </ModalBody>
                <ModalFooter>
                    <input value={infoEmpleado.nombre} disabled style={{ width: "500px" }} />
                    <Button disabled={loadingE} color="success" onClick={() => cerrarModalInfo(infoEmpleado)}>
                        <FontAwesomeIcon icon="check" size="2x" />
                    </Button>{' '}
                    <Button color="danger" onClick={cerrarModal}>
                        <FontAwesomeIcon icon="times" size="2x" />
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}
